<template>
  <button
    :type="type"
    class="
      inline-flex
      items-center
      px-4
      py-2
      border border-transparent
      text-sm
      font-medium
      rounded
      shadow-sm
      text-white
      justify-center
      capitalize
    "
    :class="{ 'text-white': dark, 'text-gray-800': !dark }"
    :disabled="loading"
  >
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
interface Props {
  dark?: boolean;
  loading?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
}

withDefaults(defineProps<Props>(), {
  dark: false,
  loading: false,
  type: "button",
});
</script>

<style lang="postcss" scoped>
button:disabled {
  @apply cursor-not-allowed pointer-events-none bg-gray-300 text-gray-400 !important;
}
</style>
